import React from "react";
import { Localize } from "components/service";
import type { TCommunicationTask } from "../helpers/communication-types-helper";

interface ICommunicationQuestionsFieldProps {
  task: TCommunicationTask;
}

const CommunicationQuestionsField: React.FC<ICommunicationQuestionsFieldProps> = ({ task }) => {
  const totalQuestions = task.questions.length;
  const openQuestions = task.questions.filter((question) => question.status === "open").length;

  if (!totalQuestions) {
    return (
      <span className="communication-questions-field communication-questions-field--empty">
        <Localize>COMMUNICATION.Text_NoQuestions</Localize>
      </span>
    );
  }

  return (
    <div className="communication-questions-field">
      <span className="communication-questions-field__count">{openQuestions}</span>
      <span className="communication-questions-field__text">
        <Localize
          questions={totalQuestions}
          open={openQuestions}
        >
          COMMUNICATION.Text_QuestionsSummary
        </Localize>
      </span>
    </div>
  );
};

export default CommunicationQuestionsField;
